module.exports = __webpack_public_path__ + "img/chess_chinesechessblack2.05b3829a.png";